import script from "./CofigurableButtonContent3Component.vue?vue&type=script&setup=true&lang=js"
export * from "./CofigurableButtonContent3Component.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__